class StorySwiperSlide extends HTMLElement {
    constructor() {
        super();
        this.casouselSlide = this.querySelector('.story__slideshow');
        this.perView = this.querySelector('.story__slideshow').getAttribute('data-view');
        var swiper = new Swiper(this.casouselSlide, {
            a11y: true,
            slidesPerView: 1.06,
            spaceBetween: 0,
            loop: false,
            speed: 500,
            autoHeight: false,
            centeredSlides: false,
            // Navigation arrows
            navigation: {
                nextEl: '.story-button-next',
                prevEl: '.story-button-prev',
            },
            breakpoints: {
                1024: {
                    slidesPerView: this.perView,
                },
                750: {
                    slidesPerView: 2,
                }
            },
        });
        swiper.on('slideChange', function (i) {

            if (i.isEnd) {
                document.querySelector('.story__overflow-hiden').classList.add("slide-is-end");
            }
            else {
                document.querySelector('.story__overflow-hiden').classList.remove("slide-is-end");
            }
        });
         if (this.querySelectorAll('.swiper-slide').length > 1){
            document.querySelector('.story__wrapper').classList.remove("story__not-slideshow");
        } else{
            document.querySelector('.story__wrapper').classList.add("story__not-slideshow");
        }
    }
}
customElements.define("story-container", StorySwiperSlide);
